const PATH_PREFIXED_HOST_ALIASES = new Set(['leads.trevi.ca']);

export function getCrmRouterBasename(locationLike: Pick<Location, 'hostname' | 'pathname'> = window.location): string | undefined {
    if (locationLike.hostname !== 'craft2.manucraft3d.com') return undefined;

    const firstSegment = locationLike.pathname.split('/').filter(Boolean)[0];
    if (!firstSegment || !PATH_PREFIXED_HOST_ALIASES.has(firstSegment)) return undefined;

    return `/${firstSegment}`;
}
